<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('expense_category')">
            <expense-top-buttons @open-modal="openModal" />
        </app-page-top-section>

        <table class="table table-bordered">
            <thead>
                <tr>
                    
                    <th>{{ $t('name') }}</th>
                    <th>{{ $t('actions') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="category in categories" :key="category.id">
                   
                    <td>{{ category.name }}</td>
                    <td>
                        <button class="btn btn-sm btn-primary" @click="editCategory(category)">Edit</button>
                        <button class="btn btn-sm btn-danger" @click="deleteCategory(category.id)">Delete</button>
                    </td>
                </tr>
            </tbody>
        </table>
        

        <expense-create-edit-modal
            v-if="isModalActive"
            v-model="isModalActive"
            :category="selectedCategory"
            @saved="fetchCategories"
        />
    </div>
</template>

<script>
import ExpenseTopButtons from './Components/ExpenseTopButtons.vue'
import ExpenseCreateEditModal from './Components/ExpenseCreateEditModal.vue'

export default {
    name: 'AppExpenseCategories',
    components: {
        ExpenseTopButtons,
        ExpenseCreateEditModal
    },
    data() {
        return {
            categories: [],
            isModalActive: false,
            selectedCategory: null,
        }
    },
    mounted() {
        this.fetchCategories();
    },
    methods: {
        fetchCategories() {
            axios.get('/expense-categories').then(res => {
                this.categories = res.data;
            });
        },
        openModal() {
            this.selectedCategory = null;
            this.isModalActive = true;
        },
        editCategory(category) {
            this.selectedCategory = category;
            this.isModalActive = true;
        },  
        deleteCategory(id) {
            if (confirm('Are you sure?')) {
                axios.delete(`/expense-categories/${id}`).then(() => {
                    this.fetchCategories();
                    alert('Deleted successfully!');
                });
            }
        }
    }
}
</script>
